'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCompose = function IoCompose(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm34.6 7.8c0.6 0.6 0.6 1.4 0 2l-2.5 2.4-4.3-4.3 2.4-2.5c0.6-0.6 1.4-0.6 2 0z m-7.6 0.8l4.3 4.3-13.8 13.5-5 1.1 1.1-5z m3 11.4l2.5-2.5v15.7c0 1-0.8 1.8-1.8 1.8h-23.9c-1 0-1.8-0.8-1.8-1.8v-23.9c0-1 0.8-1.8 1.8-1.8h15.7l-2.5 2.5h-11.6c-0.5 0-0.9 0.4-0.9 0.8v20.9s0.3 0.8 0.8 0.8h21s0.7-0.4 0.7-0.8v-11.7z' })
        )
    );
};

exports.default = IoCompose;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/compose.js
// module id = 2031
// module chunks = 0